import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMailboxBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7850_501866)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M44.9999 70.25C45.5522 70.25 45.9999 70.6977 45.9999 71.25C45.9999 71.8023 45.5522 72.25 44.9999 72.25H26.2499C25.6976 72.25 25.2499 71.8023 25.2499 71.25C25.2499 70.6977 25.6976 70.25 26.2499 70.25H44.9999Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M107.743 53.7949C107.595 47.8057 105.15 42.0934 100.903 37.8467C96.5195 33.463 90.5743 31 84.3749 31H45.495C48.4826 32.2615 51.2296 34.095 53.5673 36.4326C58.326 41.1914 60.9999 47.6451 60.9999 54.375V85.25H105C105.729 85.25 106.428 84.9601 106.944 84.4443C107.46 83.9286 107.75 83.2293 107.75 82.5V54.375L107.743 53.7949ZM109.75 82.5C109.75 83.7598 109.249 84.9676 108.358 85.8584C107.467 86.7492 106.26 87.25 105 87.25H59.9999C59.4476 87.25 58.9999 86.8023 58.9999 86.25V54.375C58.9999 48.1756 56.5369 42.2303 52.1532 37.8467C47.7695 33.463 41.8243 31 35.6249 31C35.0726 31 34.6249 30.5523 34.6249 30C34.6249 29.4477 35.0726 29 35.6249 29H84.3749C91.1047 29 97.5585 31.6739 102.317 36.4326C107.076 41.1914 109.75 47.6451 109.75 54.375V82.5Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M58.9999 105V87.25H14.9999C13.7401 87.25 12.5323 86.7492 11.6415 85.8584C10.7507 84.9676 10.2499 83.7598 10.2499 82.5V54.375C10.2499 47.6451 12.9238 41.1914 17.6825 36.4326C22.4412 31.6739 28.895 29 35.6249 29C36.1772 29 36.6249 29.4477 36.6249 30C36.6249 30.5523 36.1772 31 35.6249 31C29.4254 31 23.4802 33.463 19.0966 37.8467C14.7129 42.2303 12.2499 48.1756 12.2499 54.375V82.5C12.2499 83.2293 12.5398 83.9286 13.0555 84.4443C13.5713 84.9601 14.2705 85.25 14.9999 85.25H59.9999C60.5522 85.25 60.9999 85.6977 60.9999 86.25V105C60.9999 105.552 60.5522 106 59.9999 106C59.4476 106 58.9999 105.552 58.9999 105Z",
				fill: "#14151F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M73.9999 67.5V11.25L74.0048 11.1475C74.0561 10.6433 74.4822 10.25 74.9999 10.25H89.9999C90.5522 10.25 90.9999 10.6977 90.9999 11.25C90.9999 11.8023 90.5522 12.25 89.9999 12.25H75.9999V67.5C75.9999 68.0523 75.5522 68.5 74.9999 68.5C74.4476 68.5 73.9999 68.0523 73.9999 67.5Z",
				fill: "url(#paint0_linear_7850_501866)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_7850_501866",
		x1: 73.9999,
		y1: 68.5,
		x2: 95.2033,
		y2: 66.9274,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#E45D96"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7850_501866",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	})] })]
});
export default SvgMailboxBig;
